import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import sign from "jwt-encode";
import { claimGiftArticle } from "../../../api";
import MobileLogin from "../../rows/header/user-login/login-mobile";
import { DeepBI } from "../../../integrations";
import styles from "./styles.m.css";

export const GiftStatusPopup = ({ config, storyId, giftStatus: giftStatusProp, story, onClaimed }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [giftStatus, setGiftStatus] = useState(null);
  const [isClaiming, setIsClaiming] = useState(false);
  const [currentGiftId, setCurrentGiftId] = useState("");
  const [isGuest, setIsGuest] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);

  useEffect(
    () => {
      if (giftStatusProp) {
        if (giftStatusProp.status === "guest") {
          setIsGuest(true);
          setCurrentGiftId(giftStatusProp.giftId);
          setShowPopup(true);
        } else {
          setIsGuest(false);
          const params = new URLSearchParams(global.location && global.location.search);
          setCurrentGiftId(params.get("giftid") || "");
          setGiftStatus(giftStatusProp);
          setShowPopup(true);
        }
      }
    },
    [giftStatusProp]
  );

  if (!showPopup) return null;
  if (!isGuest && !giftStatus) return null;

  const onClose = (eventName = "GiftStatusPopup_Close_Clicked") => {
    DeepBI.pingPaywallEventTrigger(story, eventName);
    setShowPopup(false);
  };

  const handleLoginOpen = () => {
    DeepBI.pingPaywallEventTrigger(story, "GiftStatusPopup_SignInToClaim_Clicked");
    setShowLoginModal(true);
  };
  const handleLoginClose = () => setShowLoginModal(false);

  const handleClaim = async () => {
    try {
      const user = await global.userPromise.catch(() => ({}));
      if (!user || !user.userId) return;

      setIsClaiming(true);
      const userId = user.userId;
      const jwtKey = get(config, ["JwtKey"]);
      const jwtToken = sign({ userId }, jwtKey);

      const payload = {
        gift_id: currentGiftId,
        user_id: userId,
        article_id: storyId
      };

      const response = await claimGiftArticle(payload, jwtToken);
      if (response && response.status === "success") {
        DeepBI.pingPaywallEventTrigger(story, "GiftStatusPopup_Claim_Success");
        setGiftStatus(prev => ({
          ...prev,
          has_claimed: true,
          remaining_claims: Math.max(0, prev && prev.remaining_claims ? prev.remaining_claims - 1 : 0)
        }));
        // Notify parent so it can update evAccess and giftStatus in its own state
        if (onClaimed) onClaimed();
      } else {
        DeepBI.pingPaywallEventTrigger(story, "GiftStatusPopup_Claim_Failed");
        console.log(get(response, ["msg"], "Failed to claim gift"));
      }
      setIsClaiming(false);
    } catch (error) {
      console.error("Error claiming gift:", error);
      setIsClaiming(false);
    }
  };

  const isSuccess = giftStatus && giftStatus.status === "success";
  const isExpired = giftStatus && giftStatus.expired;
  const hasClaimed = giftStatus && giftStatus.has_claimed;
  const remainingClaims = (giftStatus && giftStatus.remaining_claims) || 0;

  let title = "Gift Status";
  let message = (giftStatus && giftStatus.msg) || "Checking gift link...";
  let showClaimButton = false;

  if (isGuest) {
    title = "Gifted you a Vikatan premium story";
    message = "This gift unlocks this story free of cost on signup or login.";
  } else if (isSuccess) {
    if (hasClaimed) {
      title = "Gifted you a Vikatan premium story";
      message = "You have access this story.";
    } else if (isExpired) {
      title = "Gift Expired";
      message =
        "This gift is no longer available. The Gifted Article has expired or user has already utilized all their gift claims for this month.";
    } else {
      title = "Gift Available!";
      // message = `A gift article has been shared with you! You have ${remainingClaims} gift claims remaining this month.`;
      message = "";
      // icon = "🎁";
      showClaimButton = remainingClaims > 0;
      if (remainingClaims <= 0) {
        title = "Looks like you just missed it!";
        message =
          "This gift is no longer available. The Gifted Article has expired or user has already utilized all their gift claims for this month.";
      }
    }
  } else {
    title = "Invalid Gift";
    message = (giftStatus && giftStatus.msg) || "Invalid gift link.";
  }

  const heroImage = get(story, ["hero-image-s3-key"], "");
  const storyHeadline = get(story, ["headline"], "");
  const publishedAtRaw = get(story, ["first-published-at"], get(story, ["published-at"]));
  const publishedAtFormatted = publishedAtRaw
    ? new Date(publishedAtRaw).toLocaleDateString("en-IN", { year: "numeric", month: "short", day: "numeric" })
    : "";

  return (
    <div className={styles.giftOverlay}>
      <div className={styles.giftPopup}>
        <div className={styles.giftpopupcontent}>
          <button type="button" onClick={() => onClose("GiftStatusPopup_Close_Clicked")} className={styles.closeButton}>
            &times;
          </button>
          <div className={styles.giftpopuplogincontent}>
            <div className={styles.icon}>
              <img
                src="https://images.assettype.com/vikatan/2026-03-09/6oul6cxb/gift-article-logo.png?q=100&w=224"
                alt="Gift Article Logo"
              />
            </div>
            {(isGuest || (isSuccess && !isExpired)) && <h1 className={styles.name}>Our Subscriber</h1>}
            <h3 className={styles.title}>{title}</h3>

            {isSuccess &&
              !isExpired && (
                <div>
                  <img src="https://images.assettype.com/vikatan/2026-03-19/l51d3hig/successful.png" />
                </div>
              )}

            {!hasClaimed &&
              isExpired && (
                <div>
                  <img src="https://images.assettype.com/vikatan/2026-03-30/p2ds7bk9/thatha-expired.png" />
                </div>
              )}

            {(isGuest || hasClaimed || (isSuccess && !isExpired)) && (
              <div className={styles.giftarticlestoryheader}>
                <div className={styles.giftarticlestoryheader}>
                  <div className={styles.giftarticlestoryheadercontent}>
                    {isGuest && (
                      <img src="https://images.assettype.com/vikatan/2026-03-10/recs4xm9/article-header.png" />
                    )}
                    {isSuccess && <img src="https://images.assettype.com/vikatan/2026-03-19/fp8fb87r/giftbox.png" />}
                  </div>
                  <div className={styles.giftarticlestory}>
                    <img
                      src={`https://media.vikatan.com/${heroImage}`}
                      alt={storyHeadline || "Article"}
                      className={styles.giftarticleimage}
                    />

                    <div className={styles.giftarticlecontent}>
                      {storyHeadline && (
                        <p className={styles.giftarticleheadline}>
                          &ldquo;
                          {storyHeadline}
                          &rdquo;
                        </p>
                      )}
                      {publishedAtFormatted && <span className={styles.giftarticledate}>{publishedAtFormatted}</span>}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {!hasClaimed && isExpired ? (
              <div className={styles["expired-message"]}>
                <p className={styles.message}>{message}</p>
              </div>
            ) : (
              <div>
                <p className={styles.message}>{message}</p>
              </div>
            )}

            {isGuest ? (
              <button type="button" onClick={handleLoginOpen} className={styles.loginButton}>
                {/* SIGN IN TO CLAIM */}
                Claim Your Gift
              </button>
            ) : hasClaimed ? (
              <button
                type="button"
                onClick={() => onClose("GiftStatusPopup_ReadStory_Clicked")}
                className={styles.actionButton}
              >
                Read Story
              </button>
            ) : showClaimButton ? (
              <div>
                <button
                  type="button"
                  onClick={() => {
                    DeepBI.pingPaywallEventTrigger(story, "GiftStatusPopup_ClaimYourGift_Clicked");
                    handleClaim();
                  }}
                  disabled={isClaiming}
                  className={styles.actionButton}
                >
                  {isClaiming ? "Claiming..." : "Claim your Gift"}
                </button>
                {(isGuest || !isClaiming) && <div className={styles["no-payment-message"]}>No payment required</div>}
              </div>
            ) : (
              // <button
              //   type="button"
              //   onClick={() => onClose("GiftStatusPopup_SubscribeToReadMore_Clicked")}
              //   className={styles.actionButton}
              // >
              //   Subscribe To Read More
              // </button>

              <a
                href="https://www.vikatan.com/store?utm_source=direct_web&u_medium=web_page&utm_campaign=gift-article-subscribe"
                onClick={() => DeepBI.pingPaywallEventTrigger(story, "GiftStatusPopup_SubscribeToReadMore_Clicked")}
              >
                <button type="button" className={styles.actionButton}>
                  Subscribe To Read More
                </button>
              </a>
            )}
            {showLoginModal && <MobileLogin onClose={handleLoginClose} />}
          </div>
        </div>
      </div>
    </div>
  );
};

GiftStatusPopup.propTypes = {
  config: PropTypes.object,
  storyId: PropTypes.string,
  giftStatus: PropTypes.object,
  story: PropTypes.object,
  onClaimed: PropTypes.func
};
